export const enClientPortalTaskSideDrawerPages = {
    taskSideDrawer: {
        common: {
            cancelAriaLabel: 'Cancel',
            submitAriaLabel: 'Submit',
        },
        header: {
            editTitleAriaLabel: 'Edit title',
            form: {
                updateErrorMessage: 'An error occurred while sending the changes. Please try again.',
            },
        },
        orderDetails: {
            title: 'Order data',
            orderName: 'Order name',
            valuationDate: 'Valuation date',
            orderStatus: 'Order status',
            appraiser: 'Appraiser',
            asset: 'Asset',
            portfolio: 'Portfolio',
            portfolios: 'Portfolios',
            appraiserAssignment: {
                addButton: 'Add appraiser',
                modal: {
                    customOptionName: '► External (free text)',
                    customOptionGroup: 'Unregistered appraisers',
                    title: 'Assigned appraisers',
                    cancel: 'Cancel',
                    duplicateWarning: 'The same appraiser was selected more than once. Please change one of the entries.',
                    customInfo: 'Please only use free text for unregistered appraisers. Automations only work with linked appraisers.',
                    mainAppraiser: 'Primary appraiser',
                    secondaryAppraiser: 'Secondary appraiser',
                    tertiaryAppraiser: 'Tertiary appraiser',
                    nameAndCertification: 'Name and certification',
                    remove: 'Remove',
                    addSecondary: 'Add secondary appraiser',
                    addTertiary: 'Add tertiary appraiser',
                },
            },
        },
        changeLog: {
            todayAt: 'today at {{time}}',
            onDate: 'on {{date}}',
            createdBy: 'Task created by {{userName}} {{dateOrTime}}',
            createdAutomatically: 'This task was created automatically {{dateOrTime}}',
            closedBy: 'Task completed by {{userName}} {{dateOrTime}}',
            closedAutomatically: 'This task was completed automatically {{dateOrTime}}',
        },
        details: {
            title: 'Task details',
            assignee: 'Assignee',
            customerVisibility: 'Customer visibility',
            hidden: 'Hidden',
            visible: 'Visible',
            taskType: 'Task type',
            deadline: 'Deadline',
            notSet: 'Not set',
            description: 'Description',
            showLess: 'Show less',
            showMore: 'Show more',
            form: {
                updateErrorMessage: 'An error occurred while sending the changes. Please try again.',
                updateErrorTitle: 'Error',
                hiddenSecondary: '(hidden from customers)',
                cancelAriaLabel: 'Cancel',
                submitAriaLabel: 'Submit',
            },
        },
        attachments: {
            title: 'Documents',
            downloadAllAriaLabel: 'Download all documents',
            editDocumentsAriaLabel: 'Edit documents',
            uploadDocumentsAriaLabel: 'Upload documents',
            uploadDisabledTooltip: 'For orders with an external mailbox, documents can only be sent in a message.',
            modal: {
                uploadTitle: 'Upload documents',
                editTitle: 'Edit documents',
                createButton: 'Create',
                confirmButton: 'Confirm',
                cancelButton: 'Cancel',
                dropzonePrompt: 'Select a file or upload it via drag and drop',
                nameLabel: 'Name',
                tagsLabel: 'Tags',
                unknownMimeTypeLabel: 'Unknown',
                uploadErrorAlert: {
                    title: 'Error uploading files',
                    description: 'The following files could not be uploaded successfully:',
                    supportText: 'Please try again or send a message to support@einwert.com',
                },
            },
            item: {
                edit: 'Edit',
                delete: 'Delete',
                optionsAriaLabel: 'Task attachment options',
            },
        },
    },
}
